import React from 'react';
import { Box, Typography, Container, Grid, Link, IconButton } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailIcon from '@mui/icons-material/Email';

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#1a1a1a', // Dark grey/black for corporate look
        color: '#ccc',
        py: 6,
        borderTop: '5px solid #003366', // Corporate accent top border
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>

          {/* Company Info */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold', mb: 2 }}>
              FEM TECH SOLUTION
            </Typography>
            <Typography variant="body2" sx={{ lineHeight: 1.8, mb: 2 }}>
              Empowering women through innovative hygiene technology. We provide sustainable solutions for schools, workplaces, and public spaces.
            </Typography>
            <Typography variant="body2" sx={{ color: '#888' }}>
              &copy; {new Date().getFullYear()} Fem Tech Solution. All Rights Reserved.
            </Typography>
          </Grid>

          {/* Quick Links - Simple Text List */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold', mb: 2 }}>
              QUICK LINKS
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              {['Home', 'About Us', 'Products', 'Adv & Benefits', 'Contact'].map((item) => (
                <Link
                  key={item}
                  href="#"
                  underline="hover"
                  sx={{ color: '#ccc', fontSize: '14px' }}
                >
                  {item}
                </Link>
              ))}
            </Box>
          </Grid>

          {/* Contact Details */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold', mb: 2 }}>
              CONTACT US
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              <strong style={{ color: '#fff' }}>Address:</strong><br />
              Sarakkapillaiyur, Thumbipadi, Salem - 636305
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              <strong style={{ color: '#fff' }}>Phone:</strong> +91 98426 74113
            </Typography>
            <Typography variant="body2">
              <strong style={{ color: '#fff' }}>Email:</strong> femtechsolutionsalem@gmail.com
            </Typography>

            <Box sx={{ mt: 3, display: 'flex', gap: 2 }}>
              <IconButton
                component="a"
                href="https://wa.me/919842674113"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  backgroundColor: '#25D366',
                  color: '#fff',
                  '&:hover': { backgroundColor: '#1ebe57' }
                }}
              >
                <WhatsAppIcon />
              </IconButton>
              <IconButton
                component="a"
                href="https://mail.google.com/mail/?view=cm&fs=1&to=femtechsolutionsalem@gmail.com"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  backgroundColor: '#ea4335',
                  color: '#fff',
                  '&:hover': { backgroundColor: '#d93025' }
                }}
              >
                <EmailIcon />
              </IconButton>
            </Box>
          </Grid>

        </Grid>
      </Container>
    </Box>
  );
}

export default Footer;
